export default {
  name: 'el-GR',
  global: {
    undo: 'Αναίρεση',
    redo: 'Επανάληψη',
    confirm: 'Επιβεβαίωση',
    clear: 'Καθαρισμός',
  },
  Popconfirm: {
    positiveText: 'Επιβεβαίωση',
    negativeText: 'Ακύρωση',
  },
  Cascader: {
    placeholder: 'Παρακαλώ επιλέξτε',
    loading: 'Φόρτωση',
    loadingRequiredMessage: (label: string): string =>
      `Παρακαλώ φορτώστε όλους τους απογόνους του ${label} πριν τον επιλέξετε.`,
  },
  Time: {
    dateFormat: 'yyyy-MM-dd',
    dateTimeFormat: 'yyyy-MM-dd HH:mm:ss',
  },
  DatePicker: {
    yearFormat: 'yyyy',
    monthFormat: 'MMM',
    dayFormat: 'eeeeee',
    yearTypeFormat: 'yyyy',
    monthTypeFormat: 'yyyy-MM',
    dateFormat: 'yyyy-MM-dd',
    dateTimeFormat: 'yyyy-MM-dd HH:mm:ss',
    quarterFormat: 'yyyy-qqq',
    weekFormat: 'yyyy-w',
    clear: 'ΚΑΘΑΡΙΣΜΟΣ',
    now: 'ΤΩΡΑ',
    confirm: 'ΚΛΕΙΣΙΜΟ',
    selectTime: 'Επιλογή ώρας',
    selectDate: 'Επιλογή ημερομηνίας',
    datePlaceholder: 'Επιλογή ημερομηνίας',
    datetimePlaceholder: 'Επιλογή ημερομηνίας και ώρας',
    monthPlaceholder: 'Επιλογή μήνα',
    yearPlaceholder: 'Επιλογή έτους',
    quarterPlaceholder: 'Επιλογή τριμήνου',
    weekPlaceholder: 'Επιλογή εβδομάδας',
    startDatePlaceholder: 'Ημερομηνία έναρξης',
    endDatePlaceholder: 'Ημερομηνία λήξης',
    startDatetimePlaceholder: 'Ημερομηνία και ώρα έναρξης',
    endDatetimePlaceholder: 'Ημερομηνία και ώρα λήξης',
    startMonthPlaceholder: 'Μήνας έναρξης',
    endMonthPlaceholder: 'Μήνας λήξης',
    monthBeforeYear: true,
    firstDayOfWeek: 6 as 0 | 1 | 2 | 3 | 4 | 5 | 6,
    today: 'Σήμερα',
  },
  DataTable: {
    checkTableAll: 'Επιλογή όλων στον πίνακα',
    uncheckTableAll: 'Αποεπιλογή όλων στον πίνακα',
    confirm: 'Επιβεβαίωση',
    clear: 'Καθαρισμός',
  },
  LegacyTransfer: {
    sourceTitle: 'Πηγή',
    targetTitle: 'Προορισμός',
  },
  Transfer: {
    selectAll: 'Επιλογή όλων',
    unselectAll: 'Αποεπιλογή όλων',
    clearAll: 'Καθαρισμός',
    total: (num: number): string => `Σύνολο ${num} αντικειμένων`,
    selected: (num: number): string => `${num} αντικείμενα επιλεγμένα`,
  },
  Empty: {
    description: 'Δεν υπάρχουν δεδομένα',
  },
  Select: {
    placeholder: 'Παρακαλώ επιλέξτε',
  },
  TimePicker: {
    placeholder: 'Επιλογή ώρας',
    positiveText: 'ΟΚ',
    negativeText: 'Ακύρωση',
    now: 'Τώρα',
    clear: 'Καθαρισμός',
  },
  Pagination: {
    goto: 'Μετάβαση',
    selectionSuffix: 'σελίδα',
  },
  DynamicTags: {
    add: 'Προσθήκη',
  },
  Log: {
    loading: 'Φόρτωση',
  },
  Input: {
    placeholder: 'Παρακαλώ εισάγετε',
  },
  InputNumber: {
    placeholder: 'Παρακαλώ εισάγετε',
  },
  DynamicInput: {
    create: 'Δημιουργία',
  },
  ThemeEditor: {
    title: 'Επεξεργαστής Θέματος',
    clearAllVars: 'Καθαρισμός όλων των μεταβλητών',
    clearSearch: 'Καθαρισμός αναζήτησης',
    filterCompName: 'Φιλτράρισμα ονόματος συστατικού',
    filterVarName: 'Φιλτράρισμα ονόματος μεταβλητής',
    import: 'Εισαγωγή',
    export: 'Εξαγωγή',
    restore: 'Επαναφορά στην προεπιλογή',
  },
  Image: {
    tipPrevious: 'Προηγούμενη εικόνα (←)',
    tipNext: 'Επόμενη εικόνα (→)',
    tipCounterclockwise: 'Αντίθετα των δεικτών του ρολογιού',
    tipClockwise: 'Σύμφωνα με τους δείκτες του ρολογιού',
    tipZoomOut: 'Σμίκρυνση',
    tipZoomIn: 'Μεγέθυνση',
    tipDownload: 'Λήψη',
    tipClose: 'Κλείσιμο (Esc)',
    tipOriginalSize: 'Μεγέθυνση στο αρχικό μέγεθος',
  },
}
